/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/ticket': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="#272c33"><path pid="0" data-color="color-2" d="M5 6h6v4H5z"/><path pid="1" d="M14 3v1.5c-1.2.7-2 2-2 3.5s.8 2.8 2 3.5V13H2v-1.5c1.2-.7 2-2 2-3.5s-.8-2.8-2-3.5V3h12m2-2H0v5c1.1 0 2 .9 2 2s-.9 2-2 2v5h16v-5c-1.1 0-2-.9-2-2s.9-2 2-2V1z"/></g>'
  }
})
